import { useState } from 'react';
import { Container, Paper, TextField, Button, Typography, Alert, Stack, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { api } from '../services/api';
import { PRIMARY } from '../theme';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post('/api/auth/forgot-password', { email }); setSent(true); } finally { setBusy(false); }
  };
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', bgcolor: PRIMARY }}>
      <Container maxWidth="xs">
        <Paper sx={{ p: 4 }}>
          <Typography variant="h6" gutterBottom>Reset your password</Typography>
          {sent
            ? <Alert severity="success">If an account exists for that email, a reset link has been sent.</Alert>
            : <form onSubmit={submit}>
                <Stack spacing={2}>
                  <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                  <Button type="submit" variant="contained" disabled={busy}>Send reset link</Button>
                </Stack>
              </form>}
          <Box mt={2}><Link to="/login">Back to sign in</Link></Box>
        </Paper>
      </Container>
    </Box>
  );
}
